import { codeFromCountryAcronym } from 'Components/Forms/CountryCodeSelect';

// The country of the last phone sign-in on this device, so the next phone
// sign-in starts on it instead of the United States. It travels with the
// "Last used" sign-in hint (Utils/LastLoginMethod): the same local storage,
// written only on a confirmed success, kept through log out, and cleared when
// the last-used method becomes one that is not a phone number.
//
// Only the country's two-letter code is stored, never the number.
const LAST_PHONE_COUNTRY_KEY = 'museflow:last-phone-country';

const isKnownCountry = (value: unknown): value is string =>
  typeof value === 'string' && codeFromCountryAcronym(value) !== undefined;

/** The country of the last confirmed phone sign-in here, or null if none/invalid/unavailable. */
export function getLastPhoneCountry(): string | null {
  try {
    const raw = localStorage.getItem(LAST_PHONE_COUNTRY_KEY);
    return isKnownCountry(raw) ? raw : null;
  } catch {
    // localStorage may be unavailable in some contexts.
    return null;
  }
}

/** Record the country after a confirmed phone sign-up or sign-in. Overwrites. */
export function setLastPhoneCountry(countryAcronym: string): void {
  if (!isKnownCountry(countryAcronym)) return;
  try {
    localStorage.setItem(LAST_PHONE_COUNTRY_KEY, countryAcronym);
  } catch {
    // localStorage may be unavailable in some contexts.
  }
}

/** Forget the country once the last-used method is no longer a phone number. */
export function clearLastPhoneCountry(): void {
  try {
    localStorage.removeItem(LAST_PHONE_COUNTRY_KEY);
  } catch {
    // localStorage may be unavailable in some contexts.
  }
}
